// Tracking consent, stored per browser. UK-GDPR and PECR both require an
// affirmative choice before any advertising cookie is set, so the absence of a
// decision is meaningfully different from a decline: one means "ask", the other
// means "asked, and they said no".

const STORAGE_KEY = "intakall.consent";

export type Consent = "granted" | "denied";

const VALID: readonly string[] = ["granted", "denied"];

export function getConsent(): Consent | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored && VALID.includes(stored) ? (stored as Consent) : null;
  } catch {
    // Storage blocked (Safari private mode, hardened configs). Treat it as
    // undecided: we lose the pixel, which is the correct way to fail here.
    return null;
  }
}

export function setConsent(consent: Consent): void {
  try {
    localStorage.setItem(STORAGE_KEY, consent);
  } catch {
    // Nothing to do. The visitor's choice holds for this page view; we simply
    // cannot remember it, and will ask again next time.
  }
}
